<!-- <form [formGroup]="tagForm"> -->
    <!-- <nb-tag-list (tagRemove)="onTagRemove($event)">
        <nb-tag *ngFor="let tag of selectedTags" 
            [text]="tag.tag" 
            [ngStyle]="getTagUiOptions(tag)"
            removable size="tiny"></nb-tag>
        <input type="text" nbTagInput fieldSize="tiny" fullWidth formControlName="tagsSearchKey" (ngModelChange)="onTagAutoCompleteChange($event)" [nbAutocomplete]="tagAuto" #tagSearch>
    </nb-tag-list>
    <nb-autocomplete #tagAuto (selectedChange)="onTagAutocompleteSelectionChange($event)" size="tiny">
        <nb-option *ngFor="let tag of filteredTags$ | async" [value]="tag.tag">
            {{ tag.tag }}
        </nb-option>
    </nb-autocomplete>	 -->

    <kendo-multiselect [data]="filteredTags$ | async"
                       [filterable]="true" [(ngModel)]="this.selectedTags"
                       (removeTag)="onTagRemoved($event)"
                       (filterChange)="onFilterChanged($event)"
                       (valueChange)="onValueChanged($event)"
                       [size]="this.size"
                       textField="tag"
                       valueField="id">
        <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <kendo-chip [ngStyle]="getTagUiOptions(dataItem)" [label]="dataItem.tag" [size]="this.size"></kendo-chip>
            <!-- <span [ngStyle]="getTagUiOptions(dataItem)">{{ dataItem.tag }}</span> -->
        </ng-template>
        <ng-template kendoMultiSelectTagTemplate let-dataItem>
            <kendo-chip [ngStyle]="getTagUiOptions(dataItem)" [label]="dataItem.tag" [size]="this.size"></kendo-chip>
        </ng-template>
    </kendo-multiselect>
<!-- </form> -->